import LazyLoad from 'vanilla-lazyload'
import { TARGET_SELECTOR, THRESHOLD, LOADED_SELECTOR } from '@/common/constants'

const options = {
  elements_selector: TARGET_SELECTOR,
  threshold: THRESHOLD,
  class_loaded: LOADED_SELECTOR
}

const lazyLoad = (): void => {
  if (!window.lazyLoadInstance) window.lazyLoadInstance = new LazyLoad(options)
}

document.addEventListener('DOMContentLoaded', lazyLoad)
